package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.seo.SeoBenefitsSection
import com.anjuros.website.redesign.sections.seo.SeoCertificateSection
import com.anjuros.website.redesign.sections.seo.SeoClosingSection
import com.anjuros.website.redesign.sections.seo.SeoDefinitionSection
import com.anjuros.website.redesign.sections.seo.SeoFaqSection
import com.anjuros.website.redesign.sections.seo.SeoHeroSection
import com.anjuros.website.redesign.sections.seo.SeoIncludedSection
import com.anjuros.website.redesign.sections.seo.SeoOngoingSection
import com.anjuros.website.redesign.sections.seo.SeoStatementSection
import com.anjuros.website.redesign.sections.seo.seoStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun SeoServices() {
    val title = LocalText(RdText.SEO_META_TITLE)
    val description = LocalText(RdText.SEO_META_DESCRIPTION)
    val structuredData = seoStructuredData()

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.SEO}")
        setJsonLd("ld-seo", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.SEO))
        Main {
            SeoHeroSection()
            SeoDefinitionSection()
            SeoIncludedSection()
            SeoCertificateSection()
            SeoStatementSection()
            SeoBenefitsSection()
            SeoOngoingSection()
            SeoFaqSection()
            SeoClosingSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
